module.exports = "/images/knowledge_asset_card_cover_placeholder.jpg?db15a1dd76b1592689784fade546ed73";